import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Button } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { createCityGuideCategory, updateCityGuideCategory } from '../../../../../utils/cmsUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import './Category-Create.scss';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { useDispatch } from 'react-redux';
import { fetchAllCityGuide } from '../../../cmsSlice';
import './Category-Create.scss';
import { formDataValidate } from '../../../../../utils/formUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CityGuideCategoryCreate = (props) => {
  const { toggleDrawer, cityGuide, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    if (cityGuide) {
      const currFields = { ...formData };
      currFields.name.value = cityGuide.name;
      currFields.customAttributes.value = cityGuide.customAttributes || [];
      setFormData(currFields);
    }
  }, [cityGuide]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        const payload = {
          name: formData.name.value,
          customAttributes: formData.customAttributes.value,
        };
        if (cityGuide) {
          await updateCityGuideCategory(
            {
              ...payload,
              id: cityGuide.id,
            },
            hotelId,
            language,
          );
          notificationManager('success', 'Category updated successfully');
        } else {
          await createCityGuideCategory(payload, hotelId, language);
          notificationManager('success', 'Category created successfully');
        }
        dispatch(fetchAllCityGuide(hotelId));
        toggleDrawer('', false, '');
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          cityGuide
            ? notificationManager('danger', 'Category updation failed')
            : notificationManager('danger', 'Category creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{cityGuide ? 'Edit Category' : 'Add Category'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <span className='page-title-secondary'>Details</span>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-3'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
          </div>
          <div className='row px-3 w-100'>
            <div className='col-md-12 mb-3'>
              <KeyValuePairList
                item={formData.customAttributes}
                onListChange={(e) => {
                  setFormData({ customAttributes: e });
                }}
              />
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isTabInValid}
            >
              {cityGuide ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CityGuideCategoryCreate;
